import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState, Store } from '@ngrx/store';

import * as fromGoogleServicesActions from './store/google-services.actions';
import { GoogleServicesEffects } from './store/google-services.effects';
import { googleServicesReducer } from './store/google-services.reducer';

@NgModule({
    providers: [
        provideState({ name: 'google-services', reducer: googleServicesReducer }),
        provideEffects(GoogleServicesEffects),
    ],
})
export class GoogleServicesModule {
    constructor(
        private readonly store: Store
    ) {
        setTimeout(() => {
            this.store.dispatch(fromGoogleServicesActions.Init());
        }, 500);
    }
}
